const SOCKET_CONNECTED = 'SOCKET_CONNECTED'
const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED'

export const connected = (state = false, action) => {
    switch (action.type) {
        case SOCKET_CONNECTED:
            return true

        case SOCKET_DISCONNECTED:
            return false

        default:
            return state;
    }
}


export const socketConnected = () => ({ type: SOCKET_CONNECTED })
export const socketDisconnected = () => ({ type: SOCKET_DISCONNECTED })


// WEBPACK FOOTER //
// ./src/reducers/connected/index.js